const AbstractionAiActions = {
    START_LOAD: "abstraction-ai/start-load",
    LOADED: "abstraction-ai/loaded",
    LOAD_ERROR: "abstraction-ai/load-error",
    FEEDBACK: "abstraction-ai/feedback",
};

export default AbstractionAiActions;



// WEBPACK FOOTER //
// ./app/data/meta/AbstractionAiActions.js